// src/components/Teams/TeamCard.js
import React from 'react';
import { Card, Badge } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const TeamCard = ({ team, onEdit, onDelete }) => {
    return (
        <Card className="team-card h-100 shadow-sm">
            <Card.Header className="d-flex justify-content-between align-items-center">
                <h5 className="mb-0 text-truncate">{team.name}</h5>
                <Badge bg="primary" className="ms-2 px-2 py-1">
                    {team.members?.length || 0} členů
                </Badge>
            </Card.Header>
            <Card.Body className="d-flex flex-column">
                <p className="text-muted small mb-3">
                    {team.description || 'Bez popisu'}
                </p>

                <div className="mb-3">
                    <div className="small text-muted">Weby</div>
                    <div className="fw-bold">
                        {team.websites?.length || 0}
                    </div>
                </div>

                <div className="text-muted mt-auto small mb-2">
                    <i className="fas fa-user-shield me-1"></i>
                    Vlastník: {team.ownerName || 'Neznámý'}
                </div>
            </Card.Body>
            <Card.Footer className="d-flex justify-content-between align-items-center bg-light">
                <button
                    className="btn btn-sm btn-outline-danger"
                    onClick={() => onDelete(team.id)}
                    title="Smazat tým"
                >
                    <i className="fas fa-trash"></i>
                </button>
                <div>
                    <button
                        className="btn btn-sm btn-outline-primary me-2"
                        onClick={() => onEdit(team.id)}
                        title="Upravit tým"
                    >
                        <i className="fas fa-edit"></i>
                    </button>
                    <Link to={`/teams/${team.id}`} className="btn btn-sm btn-primary">
                        <i className="fas fa-users me-1"></i> Spravovat
                    </Link>
                </div>
            </Card.Footer>
        </Card>
    );
};

export default TeamCard;